// A per-browser capability. Never put this secret in a URL or display it in the UI.
const DEVICE_KEY = 'tap-request-device-v1';
const PLAYER_KEY = 'tap-request-player-v1';
export function readRequestDevice() {
  try { const value = localStorage.getItem(DEVICE_KEY); return /^[a-f0-9]{64}$/.test(value || '') ? value : null; }
  catch { return null; }
}
export function ensureRequestDevice() {
  const existing = readRequestDevice();
  if (existing) return existing;
  try {
    const value = Array.from(crypto.getRandomValues(new Uint8Array(32)), byte => byte.toString(16).padStart(2, '0')).join('');
    localStorage.setItem(DEVICE_KEY, value);
    if (readRequestDevice() !== value) throw new Error();
    return value;
  } catch { throw new Error('신청 내역을 보관하려면 브라우저 저장 공간을 허용해 주세요. 일반 브라우저에서 다시 시도할 수 있습니다.'); }
}
export function rememberedRequester() {
  try { return localStorage.getItem(PLAYER_KEY) || ''; } catch { return ''; }
}
export function rememberRequester(id) {
  try { localStorage.setItem(PLAYER_KEY, id); } catch { /* Submission separately checks capability persistence. */ }
}
